export default "__VITE_ASSET__35299037__"